import restClient from "../restClient";


export const createInventoryMedia = async (data, files, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };

    const formData = new FormData();
    
    // Add data to formData
    if (data) {
      formData.append('data', JSON.stringify(data));
    }
    
    // Add files to formData
    if (files && files.media) {
      if (Array.isArray(files.media)) {
        files.media.forEach((file, index) => {
          formData.append('files.media', file);
        });
      } else {
        formData.append('files.media', files.media);
      }
    }

    const response = await restClient.post(`media-files`, formData, {
      ...config,
      onUploadProgress: options.onUploadProgress,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

const WEB_MAKER_MEDIA_MODULES = new Set(["website", "default-web-maker"]);

const isDefaultWebMakerMedia = (item) => {
  const entity = item?.attributes || item || {};
  return entity.meta_json?.web_maker_module === "default-web-maker";
};

const filterDefaultWebMakerMedia = (payload) => {
  if (Array.isArray(payload)) return payload.filter(isDefaultWebMakerMedia);
  if (Array.isArray(payload?.data)) {
    return { ...payload, data: payload.data.filter(isDefaultWebMakerMedia) };
  }
  if (Array.isArray(payload?.results)) {
    return { ...payload, results: payload.results.filter(isDefaultWebMakerMedia) };
  }
  if (Array.isArray(payload?.data?.results)) {
    return {
      ...payload,
      data: {
        ...payload.data,
        results: payload.data.results.filter(isDefaultWebMakerMedia),
      },
    };
  }
  return payload;
};

export const getWebsiteMedia = async ({
  module = "website",
  page = 1,
  pageSize = 48,
} = {}) => {
  const token = localStorage.getItem("token");
  const resolvedModule = WEB_MAKER_MEDIA_MODULES.has(module) ? module : "website";
  const params =
    resolvedModule === "default-web-maker"
      ? {
          "filters[type][$eq]": "image",
          "filters[module][$null]": true,
          "filters[tenant][$null]": true,
          "populate[media]": true,
          "pagination[page]": page,
          "pagination[pageSize]": pageSize,
          "sort[0]": "createdAt:desc",
        }
      : {
          module: "website",
          page,
          pageSize,
        };
  const response = await restClient.get("media-files", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });
  return resolvedModule === "default-web-maker"
    ? filterDefaultWebMakerMedia(response.data)
    : response.data;
};

export const updateWebsiteMediaMetadata = async (id, metadata = {}) => {
  const token = localStorage.getItem("token");
  const response = await restClient.put(
    `media-files/${id}`,
    {
      data: {
        module: "website",
        website_media: metadata,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const deleteInventoryMedia = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`media-files/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getInventoryMediaByInventoryId = async (inventoryId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`media-files/inventory/${inventoryId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}; 